import { db } from "../firebase";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  setDoc
} from "firebase/firestore";
import { getTotalPosicoes } from "../services/estruturaCategorias";

export async function corrigirSnapDropdown({
  modo,
  tipo,
  categoriaIds,
  idsCorretos,
  valorTrue,
  valorFalse,
  estruturaPorCategoria
}) {
  try {
    const modoFinal = modo.includes("-") ? modo : `${modo}-${tipo}`;

    console.log("🔧 Iniciando correção:", {
    modo: modoFinal,
    tipo,
    categoriaIds,
    idsCorretos,
    valorTrue,
    valorFalse,
    estruturaPorCategoria
    });

    console.log("🔧 Iniciando correção:", {
      modo: modoFinal,
      tipo,
      categoriaIds,
      idsCorretos,
      valorTrue,
      valorFalse,
      estruturaPorCategoria
    });

    const totalPorModo = {
      "oscar-indicados": 130,
      "oscar-vencedores": 24,
      "globodeouro-indicados": 92,
      "globodeouro-vencedores": 15,
      "sagawards-indicados": 30,
      "sagawards-vencedores": 6,
      "criticschoice-indicados": 146,
      "criticschoice-vencedores": 23,
      "bafta-indicados": 136,
      "bafta-vencedores": 26,
      "pga-indicados": 20,
      "pga-vencedores": 3,
      "dga-indicados": 5,
      "dga-vencedores": 1
    };

    const usuariosRef = collection(db, "usuarios");
    const usuariosSnap = await getDocs(usuariosRef);

    let contadores = {
      usuariosTotal: 0,
      comCategoriaCorrigida: 0,
      semCategoriaMasComModo: 0,
      semModo: 0,
      gravacoesSnap: 0
    };

    // 🔁 Parte 1: Corrigir apostas
    for (const usuarioDoc of usuariosSnap.docs) {
      contadores.usuariosTotal++;
      const uid = usuarioDoc.id;
      const docModoRef = doc(db, `usuarios/${uid}/snapDropdown2026/dados`);
      const docModoSnap = await getDoc(docModoRef);

      if (!docModoSnap.exists()) {
        console.warn(`❌ Documento de dados não encontrado para usuário ${uid}`);
        continue;
      }

      console.log(`👤 Corrigindo usuário ${uid}`);

      const dadosTudo = docModoSnap.data();
const dadosModo = dadosTudo[modoFinal] || {};

let usuarioFoiAlterado = false;
let precisaCriarModoZerado = !dadosTudo[modoFinal];

const dadosModoExiste = !!dadosTudo[modoFinal];
const categoriaIdTeste = categoriaIds[0];
const temCategoria = !!dadosModo[categoriaIdTeste];

if (temCategoria) {
  contadores.comCategoriaCorrigida++;
} else if (dadosModoExiste) {
  contadores.semCategoriaMasComModo++;
} else {
  contadores.semModo++;
}


let dataMaisRecente = null;

// 🔁 Corrige categorias normalmente
for (const categoriaId of categoriaIds) {
  // ... tua lógica de correção aqui ...
}

// ✅ E só depois:
let totalAcertos = 0;
let pontosDoModo = 0;

for (const [catId, conteudo] of Object.entries(dadosModo)) {
  if (catId === "porcentagem" || catId === "ultimaAtualizacao") continue;

  if (typeof conteudo?.pontos === "number") {
    pontosDoModo += conteudo.pontos;
  }

  for (const [pos, dados] of Object.entries(conteudo)) {
    if (pos === "dataAtualizacao" || pos === "pontos") continue;
    if (dados?.acertou === true) {
      totalAcertos++;
    }
  }
}

      for (const categoriaId of categoriaIds) {
        const apostasCategoria = dadosModo[categoriaId];
        if (!apostasCategoria) {
          console.warn(`⚠️ Usuário ${uid} não tem apostas em ${categoriaId}`);
          continue;
        }

        usuarioFoiAlterado = true;

        const novasPosicoes = {};
        const entradas = Object.entries(apostasCategoria).filter(
          ([key]) => key !== "dataAtualizacao"
        );
        const totalPosicoesCategoria = estruturaPorCategoria?.[categoriaId] || 0;

        console.log(`➡️ Corrigindo categoria '${categoriaId}' com ${entradas.length} posições`);

        let pontosCategoria = 0;

        for (const [posicao, dados] of entradas) {
          const id = dados.idInterno;
          const acertou = tipo === "vencedores"
            ? posicao === "1" && idsCorretos.includes(id)
            : idsCorretos.includes(id);

          novasPosicoes[posicao] = {
            ...dados,
            acertou
          };

          if (acertou) {
            totalAcertos++;
            pontosCategoria += valorTrue;
            pontosDoModo += valorTrue;
          } else {
            pontosCategoria += valorFalse;
            pontosDoModo += valorFalse;
          }
        }

        if (apostasCategoria.dataAtualizacao) {
          novasPosicoes.dataAtualizacao = apostasCategoria.dataAtualizacao;

          const data = new Date(apostasCategoria.dataAtualizacao);
          if (!dataMaisRecente || data > new Date(dataMaisRecente)) {
            dataMaisRecente = data.toISOString();
          }
        }

        novasPosicoes.pontos = pontosCategoria;
        dadosModo[categoriaId] = novasPosicoes;
      }

      // ❗ Limpa campos indevidos
      categoriaIds.forEach(cat => {
        if (dadosModo[cat]) {
          delete dadosModo[cat].porcentagem;
          delete dadosModo[cat].ultimaAtualizacao;
        }
      });

      // ✅ Atualiza somente campos válidos no modo
      const totalPosicoesModo = totalPorModo[modoFinal] || 0;
      dadosModo.porcentagem = totalPosicoesModo > 0
        ? ((totalAcertos / totalPosicoesModo) * 100).toFixed(1)
        : "0.0";
      dadosModo.ultimaAtualizacao = dataMaisRecente || new Date().toISOString();
      dadosModo.pontosmodo = pontosDoModo;
      dadosTudo[modoFinal] = dadosModo;

      if (!usuarioFoiAlterado && !precisaCriarModoZerado) {
        console.log(`⏭️ Usuário ${uid} ignorado: sem mudança`);
        continue;
      }
      
       contadores.gravacoesSnap++;

      await setDoc(docModoRef, dadosTudo, { merge: true });

      console.log(`💾 Gravado modo '${modoFinal}' para usuário ${uid}:`, {
        porcentagem: dadosModo.porcentagem,
        ultimaAtualizacao: dadosModo.ultimaAtualizacao
      });
    }

    console.log("📊 Diagnóstico Parte 1:");
    console.table(contadores);

    // 🔁 Parte 2: Ranking
    for (const usuarioDoc of usuariosSnap.docs) {
      const uid = usuarioDoc.id;
      const docRef = doc(db, `usuarios/${uid}/snapDropdown2026/dados`);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) continue;

      const dados = docSnap.data();
      if (Object.keys(dados).length === 0) continue;

      let total = 0;
      const dadosSnapshot = {};

      for (const [chave, valor] of Object.entries(dados)) {
        if (chave === "totalPontos") continue;

        const porcentagem = valor.porcentagem || "0.0";
        const ultimaAtualizacao = valor.ultimaAtualizacao || null;
        const pontosmodo = valor.pontosmodo || 0;
        dadosSnapshot[chave] = {
          porcentagem,
          ultimaAtualizacao,
          pontosmodo
        };

        for (const categoriaId of Object.keys(valor)) {
          if (!categoriaId.startsWith("melhor")) continue;

          const categoria = valor[categoriaId];
          if (typeof categoria !== "object") continue;

          const pontosCategoria = categoria.pontos || 0;
          dadosSnapshot[chave][categoriaId] = { pontos: pontosCategoria };
          total += pontosCategoria;
        }
      }

      dadosSnapshot.total = total;

      await setDoc(docRef, { totalPontos: total }, { merge: true });
      await updateDoc(doc(db, `usuarios/${uid}`), { pontuacao: total });

      const docRanking = doc(db, `ranking/usuarios/${uid}/pontos`);
      await setDoc(docRanking, dadosSnapshot);

      console.log(`🏁 Finalizado usuário ${uid} | Total: ${total} pontos`);
    }

    console.log("✅ Correção e ranking atualizados com sucesso.");
  } catch (erro) {
    console.error("❌ Erro ao corrigir apostas:", erro);
  }
}